import { motion } from 'framer-motion';

/**
 * PageHero — common hero banner used across all inner pages.
 *
 * Props:
 *  badge      {string}    — small label shown above the title
 *  title      {string}    — main heading
 *  subtitle   {string}    — paragraph below the title
 *  centered   {boolean}   — center-align text (default true)
 *  breadcrumb {ReactNode} — optional breadcrumb row rendered above the badge
 *  children   {ReactNode} — optional extra content below the subtitle (e.g. CTA buttons)
 *  className  {string}    — extra classes for the <section>
 */
export default function PageHero({
  badge,
  title,
  subtitle,
  centered = true,
  breadcrumb,
  children,
  className = '',
}) {
  const align = centered ? 'w-full mx-auto text-center' : 'max-w-3xl';

  return (
    <section
      className={`w-full section-pad-header ${className}`}
      style={{ background: 'var(--gradient-hero)' }}
    >
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        {breadcrumb && (
          <nav
            className="flex items-center gap-2 text-sm mb-6"
            style={{ color: 'rgba(255,255,255,0.6)' }}
          >
            {breadcrumb}
          </nav>
        )}

        <div className={align}>
          {/* {badge && (
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="inline-block px-4 py-1 rounded-full text-sm font-semibold mb-4"
              style={{
                background: 'rgba(201,162,39,0.2)',
                border: '1px solid var(--color-secondary)',
                color: 'var(--color-secondary-light)',
              }}
            >
              {badge}
            </motion.span>
          )} */}

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 text-balance"
          >
            {title}
          </motion.h1>

          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-base md:text-lg lg:text-xl mb-6"
              style={{ color: 'rgba(255,255,255,0.85)' }}
            >
              {subtitle}
            </motion.p>
          )}

          {children && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              {children}
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
}
